// extracted by mini-css-extract-plugin
export default {"container":"jnD2G_container"};